<div>
  <button
    [id]="id"
    type="button"
    class="flex items-center rounded-full"
    id="menu-button"
    aria-expanded="true"
    aria-haspopup="true"
    (click)="toggle($event)"
  >
    <span class="sr-only">Open options</span>
    <ark-lib-icon-name name="more"></ark-lib-icon-name>
  </button>
</div>

<ion-popover [trigger]="id" size="auto" #popoverRef>
  <ng-template>
    <ion-content>
      <ion-list lines="none">
        <ion-item
          [id]="option.separatorName ? 'sep' : idx"
          [detail]="false"
          class="border-b-0 hover:bg-gray-100"
          [button]="!option.separatorName"
          (click)="goTo($event, option)"
          *ngFor="let option of options; let idx = index"
        >
          <div
            *ngIf="!option.separatorName"
            class="text-gray-700 block text-sm cursor-pointer  {{
              option.cssClass
            }}"
            role="menuitem"
            tabindex="-1"
            id="menu-item-{{ idx }}"
          >
            <div class="flex justify-end items-center">
              <div class="h-[15px]">
                <ark-lib-icon-name
                  [name]="option.icon ?? ''"
                  [classes]="option.cssIconClass ?? ''"
                ></ark-lib-icon-name>
              </div>
              <div class="ml-[10px]">{{ option.name }}</div>
            </div>
          </div>
          <div
            class="relative inline-flex items-center justify-center w-full pt-2 min-h-[24px]"
            *ngIf="option.separatorName"
          >
            <hr class="w-64 h-px bg-[#E0C358] border-0" />
            <span
              class="absolute px-3 text-[#E0C358] bg-white -translate-x-1/2 left-1/2 text-[11px] font-bold uppercase leading-[18px] tracking-wide"
            >
              {{ option.separatorName }}
            </span>
          </div>
        </ion-item>
      </ion-list>

      <!-- <ng-container *ngFor="let option of options; let idx = index">
        <div
          *ngIf="!option.separatorName"
          (click)="goTo($event, option)"
          class="text-gray-700 block px-4 p-[12px] text-sm cursor-pointer {{
            option.cssClass
          }}"
          role="menuitem"
          tabindex="-1"
          id="menu-item-{{ idx }}"
        >
          <div class="flex justify-end items-center">
            <div class="mr-[10px]">{{ option.name }}</div>
            <div class="h-[15px]">
              <ark-lib-icon-name
                [name]="option.icon ?? ''"
                [classes]="option.cssIconClass ?? ''"
              ></ark-lib-icon-name>
            </div>
          </div>
        </div>
        <div
          class="inline-flex items-center justify-center w-full"
          *ngIf="option.separatorName"
        >
          <hr class="w-64 h-px bg-[#E0C358] border-0" />
          <span
            class="absolute px-3 text-[#E0C358] bg-white -translate-x-1/2 left-1/2 text-[11px] font-bold uppercase leading-[18px] tracking-wide"
            >{{ option.separatorName }}</span
          >
        </div>
      </ng-container> -->
    </ion-content>
  </ng-template>
</ion-popover>
